export default {
  en: {
    actions: 'Actions',
    accept: 'Accept',
    accounts: 'Accounts',
    account_number: 'Account Number',
    activity_name: 'Activity Name',
    add: 'Add',
    add_file: 'Add File',
    add_payment: 'Add Payment',
    add_new: 'Add New',
    add_new_bank_account: 'Ad New Bank Account',
    add_new_bank_statement: 'Add New Bank Statement',
    add_new_comment: 'Add New Comment',
    add_new_vendor: 'Add New Vendor',
    add_new_payday : 'Add New Payday',
    add_new_cell: 'Add New Cell',
    add_new_emails:'Add new emails',
    edit_cell: 'Edit Cell',
    cells: 'Cells',
    show_cell: 'Cell Details',
    delete_cell: 'Delete Cell',
    certifications: 'Certifications',
    skills: 'Skills',
    education: 'Education',
    other_positions: 'Other Positions',
    reason_rejection: 'Reason for Rejection',
    close: 'Close',
    delete_cell_confirm: 'Are you sure to delete this cell?',
    add_recipient: 'Add Recipient',
    and: 'and',
    annual_plan: 'Annual Plan',
    historial_annual_plan: 'Historial Annual Plan',
    agency: 'Agency',
    assign: 'Assign',
    assign_client: 'Assign Client',
    are_you_sure: 'Are you sure?',
    are_you_sure_that_you_want_to_continue:
      'Are you sure that you want to continue?',
    available: 'Available',
    a_report_will_be_generated: 'A report will be generated',
    bank: 'Bank',
    bank_account: 'bank account',
    bank_accounts: 'Bank Accounts',
    base_cost: 'Base Cost',
    building_number: 'Building',
    cancel: 'Cancel',
    category: 'Category',
    change_password: 'Change Password',
    change_status: 'Change Status',
    clear: 'Clear',
    click_here_to_update: 'Click Here to Update',
    client: 'Client',
    clients: 'Clients',
    language: 'Language',
    users: 'Users',
    client_responsibility: 'Client Responsibility',
    comments: 'Comments',
    complementary_cash_request: 'Complementary Cash Request',
    complementary_payroll: 'Complementary Payroll',
    complementary: 'Complementary',
    company: 'Company',
    companies: 'Companies',
    confirm: 'Confirm',
    confirm_message: 'Are you sure you want to continue?',
    confirm_delete: 'Confirm Delete',
    contralor_module: 'Contralor Module',
    contralor: 'Contralor',
    cost: 'Cost',
    compliance_dashboard: 'Compliance Dashboard',
    compliance_sidemenu: 'Compliance',
    compliance_module: 'Compliance Module',
    compliance_file: 'Compliance File',
    create: 'Create',
    currency: 'Currency',
    currencies: 'Currencies',
    created_by_e: 'Created by',
    classified_by_e: 'Classified by',
    approved_by: 'Approved by',
    rejected_by: 'Rejected by',
    canceled_by: 'Canceled by',
    deleted_by: 'Deleted by',
    paid_by: 'Paid by',
    on: 'on',
    current_expiration_date: 'Current Expiration Date',
    current_password: 'Current Password',
    dashboard: 'Dashboard',
    days: 'Days',
    delete: 'Delete',
    deleted: 'Deleted',
    delete_message_confirm: 'Are you sure? This Item Will Be Deleted',
    description: 'Description',
    details: 'Details',
    document: 'Document',
    documents: 'Documents',
    download: 'Download',
    date: 'Date',
    department: 'Departament',
    discrepancies: 'discrepancies',
    duration: 'Duration',
    due_date: 'Due Date',
    ehs_catalog: 'EHS Catalog',
    EHS_module: 'EHS Module',
    EHS: 'EHS',
    edit: 'Edit',
    element: 'Element',
    email: 'Email',
    end_date: 'End Date',
    end_week: 'End Week',
    escalation_rate: 'Escalation Rate',
    escalation_period: ' Escalation Period',
    expiration: 'Expiration',
    expiration_date: 'Expiration Date',
    export: 'Export',
    expenses: 'Expenses',
    expenses: 'expense',
    experience: 'Experience',
    salary: 'Salary',
    candidate: 'Candidate',
    job_title: 'Job Title',
    extension_date: 'Extension Date',
    exchange_rate: 'Exchange Rate',
    facility: 'Facility|facilities',
    file: 'File',
    files: 'Files',
    filters: 'Filters',
    folio: 'Folio',
    frequency: 'Frequency',
    from_date: 'From',
    government_fee: 'Government Fee',
    go_back: 'go back',
    Grant_Graph: 'Gantt Graph',
    go: 'Go to',
    home: 'Home',
    hours: 'Hours',
    hold: 'Hold',
    holded: 'Holded',
    hold_free: 'Hold Free',
    if_you_recently_adquired_the_permissions_try_login_in_again:
      'If you recently adquired the permissions try login in again',
    includes_expense: 'Includes Expenses',
    information: 'Information',
    insured_amount: 'Insured Amount',
    amount: 'Amount',
    insurance_company: 'Insurance Company',
    insurance_expiration_date: 'Insurance Expiration Date',
    insurance_file: 'Insurance File',
    i_am_sure: 'I am sure',
    item_added: 'Item Added',
    item_deleted: 'Item Deleted',
    item_updated: 'Item Updated',
    lease_rate: 'Lease Rate',
    link_expenses: 'Link Expenses',
    link_payrolls: 'Link Payrolls',
    logout: 'Logout',
    loading: 'Loading',
    maintenance: 'Maintenance',
    month: 'Month',
    months: 'Months',
    name: 'Name',
    none: 'None',
    next_period: 'Next period',
    new: 'New',
    new_email:'New Email',
    new_payday:'New Payday',
    new_password: 'New Password',
    new_plural_male: 'New',
    notifications: 'Notifications',
    notify: 'Notify',
    notify_invoicing: 'Notify Invoicing',
    notify_sca: 'Notify SCA',
    notify_ageing: 'Notify Ageing',
    notify_open_expenses: 'Notify Open Expenses',
    cc: 'Cc',
    notify_funding: 'Notify Funding',
    notify_shelter_fee: 'Notify Shelter Fee',
    not_authorized: 'Not authorized',
    no_comments: 'No comments',
    no_more_results: 'No More Results',
    no_results: 'No Results',
    none_notifications_to_show: 'None Notifications to show',
    none_activities_to_show: 'None Activities to show',
    on_time: 'On Time',
    once_the_email_is_sent_you_can_not_undo_this_action:
      'Once the email is sent you can NOT undo this action',
    once_approved_you_can_not_undo_this_action:
      'Once approved, you can NOT undo this action',
    options: 'Options',
    other: 'Other',
    password_confirmation: 'Password Confirm',
    passwords_do_not_match: 'Passwords do not match',
    payday:'Payday',
    payroll: 'Payroll',
    period: 'Period',
    periods: 'periods',
    permit: 'Permit',
    permit_name: 'Permit Name',
    complete_qb_invoice_number_before_this_action:
      'Please, Complete the QB Invoice column before click this action',
    property_tax: 'Property Tax',
    qb_invoice: 'QB Invoice',
    recipients: 'Recipients',
    recipient: 'Recipient',
    regulation: 'Regulation',
    regenerate_invoice: 'Regenerate Invoice',
    regenerate: 'Regenerate',
    report_generated: 'Report generated',
    resend_invoice: 'Resend Invoice',
    resend: 'Resend',
    savings: 'Savings',
    save: 'Save',
    saved: 'Saved',
    search: 'Search',
    search_by_name: 'Search By Name',
    search_frequency: 'Search Frequency',
    select_a_client: 'Select a Client',
    since: 'Since',
    shelter_fee: 'Shelter Fee',
    show_files:'Show Files',
    show_payment: 'Show Payment',
    show_pdf: 'Show PDF',
    show_historial_info_message:
      'The information showed is not the latest one, it is a historial.',
    sq_ft: 'Sq Ft',
    start: 'Start',
    start_date: 'Start Date',
    publish_date: 'Publish Date',
    start_week: 'Start Week',
    status: 'Status',
    status_compliance: 'Status Compliance',
    status_compliance_details: 'Status Compliance Details',
    submit: 'Submit',
    succesfull: 'Success',
    success: 'Success',
    succesfull_delete: 'The Selected Item was Successfully Deleted',
    tacna_responsibility: 'TACNA Responsibility',
    terms: 'Terms',
    term: 'Term',
    the_current_exchange_rate_is: 'The current exchange rate is',
    this_user_is_not_allowed_to_see_this_module:
      'This user is NOT allowed to see this module',
    this_action_will_change_the_hold_status:
      'This action will change the Hold status',
    third_party_fee: 'Third Party Fee',
    title: 'Title',
    to_date: 'To',
    transaction: 'Transaction',
    type: 'type|types',
    type_the_following_code_to_continue:
      'Type the following number to continue',
    update_exchange_rate: 'Update Exchange Rate',
    expense_exclusive_report: 'Expense Exclusive Report',
    update_vendor_email: 'Update Vendor Email',
    update_payment_file:'Update Payment File',
    update: 'Update',
    upload_file: 'upload file',
    upload_pdf: 'Upload PDF',
    validate: 'Validate',
    vendor: 'Vendor',
    vendors:'Vendors',
    week: 'Week',
    year: 'Year',
    view_cv: 'View CV',
    Major: 'Major',
    //Accounting
    account: 'Account',
    accounting: 'Accounting',
    accounting_module: 'Accounting Module',
    active_in_vendor_portal:'active in vendor portal',
    auto_generated:'auto-generated',
    add_tax_return: 'Add Tax Return',
    add_vendor_payday:'add vendor payday',
    approve: 'Approve',
    apply_filters: 'Apply Filters',
    automatic:'automatic',
    bank_statement: 'Bank Statement',
    bank_statements: 'Bank Statements',
    bi_report: 'Bi Report',
    blacklist: 'Blacklist',
    confirm_tax_return_approve_message:
      'The selected Tax return Requests will be approved, Are you sure?',
    confirm_sign_expense_message:
      'You are about to manually Sign this Expense, Are you sure?',
    clear_filters: 'Clear Filters',
    check: 'Check',
    expenses_by_category: 'Expenses by Category',
    final_period: 'Final Period',
    invoiced_expenses_by_client: 'Invoiced expenses by client',
    pending_expenses_by_client: 'Pending expenses by client',
    quantity: 'Quantity',
    rejected_expenses_by_client: 'Rejected expenses by client',
    initial_period: 'Initial Period',
    invoiced_plural: 'Invoiced',
    invoice_linked: 'Invoice Linked',
    paid: 'Paid',
    payment_method: 'Payment Method',
    payment_file:'Payment File',
    pending: 'Pending',
    pending_plural: 'Pending',
    policy: 'Policy',
    rejected_plural: 'Rejected',
    requests:'Requests',
    requested: 'Requested',
    requested_amount: 'Requested Amount',
    sign: 'Sign',
    signature:'Signature',
    Select: 'Select',
    cash_request: 'Cash Request',
    cash_request_account: 'Cash Request Account',
    tax_return: 'Tax Return',
    total: 'Total',
    transfer: 'Transfer',
    unit_cost: 'Unit Cost',
    update_expense: 'Update Expense',
    sign_pdf: 'Sign Pdf',
    //Months
    january: 'January,',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
    //A
    above_hourly_rate: 'above hourly rate',
    active:'active',
    add_account_number:'Add account number',
    add_comment_delete: 'Add Comment',
    add_comment_reject: 'Add Comment',
    add_client:'Add Client',
    address: 'address',
    address_number: 'address number',
    aging: 'aging',
    approval_date: 'approval date',
    apportionment:'Apportionment',
    attention: 'Attention',
    amount_invalid:'the sum of the amounts must be equal to the total of the invoice',
    //B
    bulk: 'bulk',
    bundle: 'bundle',
    bundle: 'bundles',
    by_client: 'by client',
    by_status: 'by status',
    budget:'Budget',
    budget_category:'by Category',
    budget_departament:'by Departament',
    //C
    can_multireview: 'can multireview',
    carrier: 'carrier',
    capturist: 'capturist',
    category_invalid:'select category',
    categories:'Categories',
    check_next_cash_request:'check next cash request',
    city: 'city',
    classify: 'classify',
    client_updated: 'client updated',
    client_saved: 'client saved',
    click_to_send:'click to send',
    client_invalid:'client invalid',
    client_repeted:'client repeted',
    code: 'code',
    color: 'color',
    comment:'comment',
    comment_delete: 'Delete Comment:',
    comment_reject: 'Reject Comment:',
    compliance_by_status:'Compliance by status',
    complementary_payrolls: 'complementary',
    completed:'completed',
    completed_late:'Completed (Late)',
    confirmation_date: 'confirmation date',
    container: 'container|containers',
    container_type: 'container type',
    contry:'contry',
    contrast:'contrast',
    correct: 'correct',
    created_by: 'created by',
    creation_date: 'creation date',
    current_month:'Current Month',
    //D
    damaged: 'damaged',
    departament:'Departament',
    departaments:'Departaments',
    dashboard_settings:'dashboard settings',
    default:'default',
    darwin_account: 'darwin account',
    destination: 'destination',
    difference:'difference',
    direct:'direct',
    direct_required: 'directs',
    digizen:'Digizen',
    disabled:'Disabled',
    documentation:'Documentation',
    done: 'done',
    do_you_want_send_shelter_fee:'Do you want to send pending shelter fees?',
    downloadDocuments:'download Documents',
    driver: 'driver',
    //E
    edit_direct: 'edit direct',
    ehs_status: 'EHS Status',
    english_description: 'english description',
    enabled:'Enabled',
    entry: 'entry|entries',
    entry_id: 'Entry ID',
    entry_report: 'Entry Report',
    emails:'emails',
    entity:'Entity',
    //F
    facility_saved: 'facility saved',
    facility_update: 'facility update',
    file:'file',
    from_or_equal: 'from or equal',
    flammable:'flammable',
    //G
    general:'general',
    generate:'generate',
    //H
    headcount:'headcount',
    headquarter: 'headquarter',
    headquarter_updated: 'headquarter updated',
    hired:'hired',
    hsbc:'HSBC',
    //I
    id:'id',
    is_active:'is active',
    is_direct_funds_mode:'is direct funds mode',
    is_review_at_origin:'is review at origin?',
    is_this_file_a_packing_slip:'Is this file a Packing Slip?',
    in_inventary:'In inventary',
    in_compliance:'In Compliance',
    in_review:'In Review',
    indirect_required:'indirects',
    company_profile:'Company Profile',
    invoice:'invoice',
    invoice_day:'invoice day',
    invoice_file:'Invoice File',
    invoice_type:'invoice type',
    it_doesn_not:'it does not',
    invalid_date:'Invalid date',
    incomplete:'incomplete',
    ingnore_taxes:'ignore taxes',
    //J
    //L
    label: 'label',
    last_update:'last update',
    latitude:'latitud',
    length: 'length',
    load_order: 'load order',
    located_at: 'located at',
    location: 'location',
    locked: 'Locked',
    longitude:'longitud',
    //M
    main_email:'main email',
    mail_server:'mail server',
    mail:'mail',
    manager_email: 'manager email',
    manager_name: 'manager name',
    manager_phone: 'manager phone',
    manual_expense: 'Manual expense',
    max_hours_for_regular_rate: 'max hours for regular rate',
    missing_category_or_client: 'missing category or client',
    model: 'model',
    market_average:'market average',
    mxn_funds_transfer: 'mxn funds transfer',
    MXN:'MXN',
    //N
    next: 'next',
    no: 'no',
    no_order: '# order',
    no_part: '# part',
    no_assigned_documents:'No assigned documents',
    number: 'number',
    new_expense: 'new expense',
    notes:'notes',
    //O
    ok: 'ok',
    order_date: 'order date',
    order_status: 'order status',
    or_new_company: 'or new company',
    original: 'original',
    other_emails:'other emails',
    overtime:'overtime',
    //P
    pallets_in_warehouse_by_client: 'pallets in warehouse by client',
    purchase_orders:'Purchase Orders',
    pay_date: 'Pay Date',
    pending_shelter_fees:'pending Shelter Fees',
    percentage:'Percentage',
    percent_invalid:'the sum of the percentages must be equal to 100',
    planned: 'planned',
    plates: 'plates',
    po_number: 'PO Number|Purchase Order',
    phone:'phone',
    position:'position',
    position_title:'position title',
    previous: 'previous',
    provider: 'provider',
    preview: 'preview',
    progress:'progress',
    precisoft:'Precisoft',
    //Q
    quality:'Quality',
    //R
    registers_will_be_exported:'registers will be exported',
    rate: 'rate|rates',
    rate_updated: 'rate updated',
    retained:'retained',
    rfc:'RFC',
    reject: 'Reject',
    rejected:'Rejected',
    recruitment:'recruitment',
    remaining_days:'remaining days',
    repse:'REPSE',
    representative: 'representative',
    recepcion: 'Reception',
    required:'required',
    requests:'Solicitudes',
    request_inventary: 'request inventary',
    request_date:'request date',
    request_documents:'request documents',
    requirement_number: 'requirement number',
    requirement_key: 'requirement key',
    retained_iva:'Retained IVA',
    retained_isr:'Retained ISR',
    resume: 'resume',
    review_at_origin:'review at origin',
    review_order: 'review order|review orders',
    review_orders: 'Review Orders',
    reviewed_by: 'reviewed by',
    reviewer: 'reviewer',
    rfc: 'RFC',
    //S
    salary_survey:'salary survey',
    salary_comparison:'salary comparison',
    save_settings:'save settings',
    sca_file_name: 'SCA file name',
    schedule_day_invoice: 'schedule day invoice',
    send:'send',
    serie: 'serie',
    series: 'series',
    short_name: 'short name',
    shift:'shift',
    sidebar_salary_survey:'Salary Survey',
    sidebar_salary_comparison:'Salary Comparison',
    sidebar_human_resources:'Human Resources',
    sidebar_contralor_report:'Contralor Report',
    sidebar_contralor_config:'Config',
    sidebar_entries: 'Entries',
    import_export: 'Import & Export',
    sidebar_load_order: 'Load Orders',
    sidebar_review_orders: 'Review Orders',
    sidebar_discrepancy: 'Discrepancies',
    soon_to_expired: 'Soon to expired',
    state: 'state',
    subject:'subject',
    subtotal:'Subtotal',
    subtotals:'Subtotals',
    supplier: 'supplier',
    //T
    tax:'Tax',
    tacna_average:'TACNA average',
    test:'test',
    there_is:'There is',
    this_entry_will_change_to: 'this entry will change to',
    this_is_RO: 'this is RO',
    this_review_order_status_will_change_to_ready_for_review:'This review order status will change to Ready for review.',
    this_will_request_a_inventary: 'this will request a inventary.',
    time_period:'time period',
    timeline: 'timeline',
    to_or_equal: 'to or equal',
    tracking: 'tracking',
    transporter: 'transporter',
    trailer: 'trailer',
    //U
    unlocked: 'Unlocked',
    unit_cost:'unit cost',
    updated: 'updated',
    ups:'ups',
    update_vendor_payday:'update vendor payday',
    usd_funds_transfer: 'usd funds transfer',
    USD:'USD',
    USD_EST:'USD EST.',
    user:'user',
    //V
    validate_document:'validate document',
    validations: 'validations',
    vendor_name:'vendor name',
    vendor_email:'vendor email',
    //W
    warehouse: 'warehouse',
    warehouse_aging: 'warehouse aging',
    warehouse_code: 'warehouse code',
    weight: 'weight',
    widget_compliance_by_status:'Compliance - Compliance by status',
    widget_discrepancies_by_supplier:'Discrepancies - by supplier',
    widget_discrepancies_by_type:'Discrepancies - By type',
    widget_discrepancies_by_client:'Discrepancies - By client',
    widget_ehs_by_status:'EHS - Compliance by status',
    widget_entries_by_aging:'Entries - By Aging',
    widget_entries_by_warehouse_capacity:'Entries - Warehouse Capacity',
    widget_entries_by_status: 'Entries - By status',
    widget_invoiced_expenses:'Accounting - Invoiced Expenses',
    widget_load_order_by_status:'Load order - By status',
    widget_pending_expenses:'Accounting - Pending Expenses',
    widget_rejected_expenses:'Accounting - Rejected Expenses',
    widget_review_oder_by_client:'Review Order - By Client',
    widget_review_oder_by_status:'Review Order - By Status',
    //X
    //Y
    yes: 'Yes',
    //Z
    zip: 'zip',
    zone: 'zone',
    zone_id: 'ID Zone'
  },
  es: {
    actions: 'Acciones',
    accept: 'Aceptar',
    account_number: 'Numero de Cuenta',
    activity_name: 'Nombre de Actividad',
    add: 'Agregar',
    add_file: 'Agregar Archivo',
    add_payment: 'Agregar Pago',
    add_new: 'Agregar Nuevo',
    add_new_bank_account: 'Agregar Nueva Cuenta Bancaria',
    add_new_bank_statement: 'Agregar Nuevo Estado de Cuenta Bancaria',
    add_new_comment: 'Agregar Nuevo Commentario',
    add_new_vendor: 'Agregar Nuevo Proveedor',
    add_new_payday : 'Agregar Nuevo Día de Pago',
    add_new_cell: 'Agregar Nueva Celda',
    add_new_emails:'Agregar nuevo correo electrónicos',
    edit_cell: 'Editar Celda',
    cells: 'Celdas',
    show_cell: 'Detalles de Celda',
    delete_cell: 'Eliminar Celda',
    certifications: 'Certificaciones',
    skills: 'Habilidades',
    education: 'Educación',
    other_positions: 'Otras posiciones',
    reason_rejection: 'Motivo de Rechazo',
    close: 'Cerrar',
    delete_cell_confirm: '¿Estás seguro que deseas eliminar la celda?',
    add_recipient: 'Agregar Destinatario',
    and: 'y',
    agency: 'Agencia',
    assign: 'Asignar',
    assign_client: 'Asignar Cliente',
    are_you_sure: '¿Estás Seguro?',
    are_you_sure_that_you_want_to_continue:
      '¿Estás Seguro que deseas continuar?',
    annual_plan: 'Plan Anual',
    historial_annual_plan: 'Historial Plan Anual',
    available: 'Disponible',
    a_report_will_be_generated: 'Un reporte será generado',
    bank: 'Banco',
    bank_account: 'Cuenta Bancaria',
    bank_accounts: 'Cuentas Bancarias',
    base_cost: 'Costo Base',
    building_number: 'Planta',
    cancel: 'Cancelar',
    category: 'Categoría',
    categories: 'categorías',
    change_password: 'Cambiar contraseña',
    change_status: 'Cambiar Estado',
    clear: 'Limpiar',
    click_here_to_update: 'Clic aquí para actualizar',
    client: 'Cliente',
    clients: 'Clientes',
    language: 'Idioma',
    users: 'Usuarios',
    client_responsibility: 'Responsabilidad de Cliente',
    comments: 'Comentarios',
    complementary_cash_request: 'Cash Request Complementario',
    complementary_payroll: 'Complementarias',
    complementary: 'Complementaria',
    company: 'Compañia',
    companies: 'Compañias',
    confirm: 'Confirmar',
    confirm_message: '¿Estás seguro que deseas continuar?',
    confirm_delete: 'Confirmar Borrado',
    contralor_module: 'Módulo de Contralor',
    contralor: 'Contralor',
    cost: 'Costo',
    compliance_dashboard: 'Dashboard Cumplimiento',
    compliance_sidemenu: 'Cumplimiento',
    compliance_module: 'Módulo de Contratos',
    compliance_file: 'Archivo de Contrato',
    create: 'Crear',
    currency: 'Moneda',
    currencies: 'Monedas',
    created_by_e: 'Creado por',
    classified_by_e: 'Clasificado por',
    approved_by: 'Aprobado por',
    rejected_by: 'Rechazado por',
    canceled_by: 'Cancelado por',
    deleted_by: 'Eliminado por',
    paid_by: 'Pagado por',
    on: 'el',
    current_expiration_date: 'Fecha de Expiración Actual',
    current_password: 'Contraseña Actual',
    dashboard: 'Dashboard',
    days: 'Días',
    delete: 'Eliminar',
    deleted: 'Eliminado',
    delete_message_confirm: '¿Estás Seguro? Este Elemento Será Eliminado',
    description: 'Descripción',
    details: 'Detalles',
    document: 'Documento',
    documents: 'Documentos',
    download: 'Descargar',
    date: 'Fecha',
    department: 'Departamento',
    discrepancies: 'discrepancias',
    duration: 'Duración',
    due_date: 'Fecha de Pago',
    ehs_catalog: 'Catálogo EHS',
    EHS_module: 'Módulo EHS',
    EHS: 'EHS',
    edit: 'Editar',
    element: 'Elemento',
    email: 'Correo Electrónico',
    end_date: 'Fecha Fin',
    end_week: 'Semana Final',
    escalation_rate: 'Incremento Pie Cuadrado',
    escalation_period: ' Periodo de Incremento',
    expiration: 'Expiración',
    expiration_date: 'Fecha de Expiración',
    export: 'Exportar',
    expenses: 'Gastos',
    expense: 'gasto',
    experience: 'Experiencia',
    salary: 'Salario',
    candidate: 'Candidato',
    job_title: 'Título profesional',
    extension_date: 'Fecha de Extensión',
    exchange_rate: 'Tipo de Cambio',
    expense_exclusive_report: 'Reporte Exclusivo de Gastos',
    facility: 'Planta|plantas',
    file: 'Archivo',
    files: 'Archivos',
    filters: 'Filtros',
    folio: 'Folio',
    frequency: 'Frecuencia',
    from_date: 'Desde',
    government_fee: 'Cuota del Gobierno',
    go_back: 'atrás',
    Grant_Graph: 'Gráfico de Gantt',
    go: 'Ir a',
    home: 'Inicio',
    hours: 'Horas',
    hold: 'Retener',
    holded: 'Retenenido',
    hold_free: 'Liberado',
    if_you_recently_adquired_the_permissions_try_login_in_again:
      'Si ha adquirido los permisos recientemente, intenta iniciar nuevamente sesión',
    includes_expense: 'Incluye Gastos',
    information: 'Información',
    insured_amount: 'Monto Asegurado',
    amount: 'Monto',
    insurance_company: 'Compañia de Seguros',
    insurance_expiration_date: 'Expiración del Seguro',
    insurance_file: 'Archivo de Seguro',
    i_am_sure: 'Estoy seguro',
    item_added: 'Elemento Añadido',
    item_deleted: 'Elemento Eliminado',
    item_updated: 'Elemento Actualizado',
    lease_rate: 'Tarifa Pie Cuadrado',
    link_expenses: 'Ligar Gastos',
    link_payrolls: 'Ligar Nóminas',
    logout: 'Cerrar Sesión',
    loading: 'Cargando',
    maintenance: 'Mantenimiento',
    month: 'Mes',
    months: 'Meses',
    name: 'Nombre',
    none: 'Ninguno',
    next_period: 'Siguiente periodo',
    new: 'Nuevo',
    new_email:'Nuevo Correo',
    new_payday:'Nuevo Día de Pago',
    new_password: 'Nueva Contraseña',
    new_plural_male: 'Nuevas',
    notifications: 'Notificaciones',
    notify: 'Notificar',
    notify_invoicing: 'Notify Invoicing',
    notify_sca: 'Notify SCA',
    notify_ageing: 'Notify Ageing',
    notify_open_expenses: 'Notify Open Expenses',
    cc: 'Cc',
    notify_funding: 'Notify Funding',
    notify_shelter_fee: 'Notify Shelter Fee',
    not_authorized: 'No Autorizado',
    no_comments: 'Sin comentarios',
    no_more_results: 'Sin más Resultados',
    no_results: 'Sin Resultados',
    none_notifications_to_show: 'Sin notificaciones para mostrar',
    none_activities_to_show: 'Sin Actividades para mostrar',
    on_time: 'En Tiempo',
    once_the_email_is_sent_you_can_not_undo_this_action:
      'Una vez enviado el correo no podrás deshacer esta acción',
    once_approved_you_can_not_undo_this_action:
      'Una vez aprobado no podrás deshacer esta acción',
    options: 'Opciones',
    other: 'Otro',
    password_confirmation: 'Confirmar Contraseña',
    passwords_do_not_match: 'Las contraseñas no coinciden',
    payday:'Día de Pago',
    payroll: 'Nómina',
    period: 'Periodo',
    periods: 'periodos',
    permit: 'Permiso',
    permit_name: 'Nombre de Permiso',
    complete_qb_invoice_number_before_this_action:
      'Por favor, completa el campo QB Invoice antes de realizar esta acción',
    property_tax: 'Impuesto de Propiedad',
    qb_invoice: 'QB Invoice',
    recipients: 'Destinatarios',
    recipient: 'Destinatario',
    regulation: 'Regulación',
    regenerate_invoice: 'Regenerar Factura',
    regenerate: 'Regenerar',
    report_generated: 'Reporte Generado',
    resend_invoice: 'Reenviar Factura',
    resend: 'Reenviar',
    savings: 'Ahorros',
    save: 'Guardar',
    saved: 'Guardado',
    search: 'Buscar',
    search_by_name: 'Buscar por Nombre',
    search_frequency: 'Buscar Frecuencia',
    select_a_client: 'Seleccionar Cliente',
    since: 'Desde',
    shelter_fee: 'Shelter Fee',
    show_files:'Ver Archivos',
    show_payment: 'Ver Pago',
    show_pdf: 'Mostrar PDF',
    show_historial_info_message:
      'La información mostrada no es la actual, es un historial.',
    sq_ft: 'Pie Cuadrado',
    start: 'Inicio',
    start_date: 'Fecha de Inicio',
    publish_date: 'Fecha de Publicación',
    start_week: 'Semana Inicial',
    status: 'Estado',
    status_compliance: 'Estatus de Cumplimiento',
    status_compliance_details: 'Detalles de Estatus de Cumplimiento',
    submit: 'Enviar',
    succesfull: 'Correcto',
    success: 'Correcto',
    succesfull_delete: 'El Elemento Seleccionado fue Eliminado Correctamente',
    tacna_responsibility: 'Responsabilidad de TACNA',
    terms: 'Términos',
    term: 'Término',
    the_current_exchange_rate_is: 'El tipo de cambio actual es',
    this_user_is_not_allowed_to_see_this_module:
      'Este usuario NO tiene permitido ver este módulo',
    this_action_will_change_the_hold_status:
      'Esta acción cambiará el estado de Retener',
    third_party_fee: 'Cuota de Terceros',
    title: 'Título',
    to_date: 'Hasta',
    transaction: 'Transacción',
    type: 'tipo|tipos',
    type_the_following_code_to_continue:
      'Teclea el siguiente número para continuar',
    update_exchange_rate: 'Actualizar Tipo de Cambio',
    update_vendor_email: 'Actualizar Correo de Proveedor',
    update_payment_file:'Actualizar Comprobante',
    update: 'Actualizar',
    upload_file: 'subir archivo',
    upload_pdf: 'Subir PDF',
    validate: 'Validar',
    vendor: 'Proveedor',
    vendors:'Proveedores',
    week: 'Semana',
    year: 'Año',
    view_cv: 'Ver CV',
    major: 'Especialidades',
    //Accounting
    account: 'Cuenta',
    accounts: 'Cuentas',
    accounting: 'Contabilidad',
    accounting_module: 'Módulo de Contabilidad',
    add_tax_return: 'Agregar Retorno de IVA',
    add_vendor_payday:'agregar payday de proveedor',
    approve: 'Aprobar',
    apply_filters: 'Aplicar Filtros',
    automatic:'automático',
    bank_statement: 'Estado de Cuenta',
    bank_statements: 'Estados de Cuenta',
    bi_report: 'Reporte Bi',
    blacklist: 'Lista Negra',
    confirm_tax_return_approve_message:
      'Se aprobarán las solicitudes de Retorno de IVA seleccionadas ¿Estás Seguro?',
    confirm_sign_expense_message:
      'Estás por aprobar manualmente este gasto, ¿Estás seguro?',
    clear_filters: 'Limpiar Filtros',
    check: 'Cheque',
    expenses_by_category: 'Gastos por Categoría',
    final_period: 'Periodo Final',
    invoiced_expenses_by_client: 'Gastos por Pagar por Cliente',
    pending_expenses_by_client: 'Gastos Pendientes por Cliente',
    quantity: 'Cantidad',
    rejected_expenses_by_client: 'Gastos Rechazados por Cliente',
    initial_period: 'Periodo Inicial',
    invoiced_plural: 'Por Pagar',
    invoice_linked: 'Factura ligada',
    paid: 'Pagado',
    payment_method: 'Método de Pago',
    payment_file:'Comprobante de Pago',
    pending: 'Pendiente',
    pending_plural: 'Pendientes',
    policy: 'Póliza',
    rejected_plural: 'Rechazados',
    request:'Solicitudes',
    requested: 'Solicitado',
    requested_amount: 'Cantidad Solicitada',
    sign: 'Firmar',
    signature:'Firma',
    Select: 'Seleccionar',
    cash_request: 'Cash Request',
    cash_request_account: 'Cuenta para Cash Request',
    tax_return: 'Retorno de IVA',
    total: 'Total',
    transfer: 'Transferencia',
    unit_cost: 'Costo por Unidad',
    update_expense: 'Actualizar Gasto',
    sign_pdf: 'Firmar Pdf',
    //Meses
    january: 'Enero',
    february: 'Febrero',
    march: 'Marzo',
    april: 'Abril',
    may: 'Mayo',
    june: 'Junio',
    july: 'Julio',
    august: 'Agosto',
    september: 'Septiembre',
    october: 'Octubre',
    november: 'Noviembre',
    december: 'Diciembre',
    //A
    above_hourly_rate: 'above hourly rate',
    active:'activo',
    active_in_vendor_portal:'Activar en protal de proveedores',
    auto_generated:'Generar Automaticamente',
    add_account_number:'Agregar numero de cuenta',
    add_comment_delete: 'Agregue comentario',
    add_comment_reject: 'Agregue comentario',
    add_client:'Agregar Cliente',
    address: 'dirección',
    address_number:'numero de dirección',
    aging: 'aging',
    approval_date: 'fecha de aprobación',
    apportionment:'Prorrateo',
    attention: 'Atención',
    amount_invalid:'la suma de los montos debe ser igual al total de la factura',
    //B
    bulk: 'bulto',
    bundle: 'paquete',
    bundles: 'paquetes',
    by_client: 'por cliente',
    by_status: 'por estado',
    budget:'Presupuesto',
    budget_category:'Por Categoria',
    budget_departament:'Por Departamento',
    //C
    can_multireview: 'can multireview',
    carrier: 'transportista',
    capturist: 'capturista',
    category_invalid:'seleccionar categoria',
    check_next_cash_request:'revisar siguiente Cash Request',
    city: 'ciudad',
    classify: 'clasificar',
    client_updated: 'cliente actualizado',
    client_saved: 'cliente guardado',
    click_to_send:'clic para enviar',
    client_invalid:'cliente invalido',
    client_repeted:'cliente repetido',
    code: 'código',
    color: 'color',
    comment:'Comentario',
    comment_delete: 'Comentario de Eliminación:',
    comment_reject: 'Comentario de rechazo:',
    complementary_payrolls: 'Complementarias',
    completed:'Completado',
    completed_late:'Completado (Retrazo)',
    compliance_by_status:'Estatus de Cumplimiento',
    confirmation_date: 'fecha de confirmación',
    container: 'contenedor|contenedores',
    container_type: 'tipo contenedor',
    contrast:'contrast',
    contry:'país',
    correct: 'correcto',
    created_by: 'creado por',
    creation_date: 'fecha de creacion',
    current_month: 'Mes Actual',
    //D
    damaged: 'dañado',
    departament:'Departamento',
    departaments:'Departamentos',
    dashboard_settings:'configurar dashboard',
    darwin_account: 'darwin account',
    destination: 'destino',
    default:'por defecto',
    difference:'diferencia',
    direct:'directo',
    direct_required:'directos',
    digizen:'Digizen',
    disabled:'Desactivado',
    documentation:'Documentación',
    done: 'listo',
    do_you_want_send_shelter_fee:'¿Desea enviar los Shelter Fee pendientes?',
    downs:'downs',
    downs:'bajas',
    downloadDocuments:'descarcargar documentos',
    driver: 'chofer',
    //E
    edit_direct: 'editar directos',
    ehs_status: 'Estatus de EHS',
    english_description: 'description en inglés',
    enabled:'Activado',
    entry: 'entrada|entradas',
    entry_id: 'ID Entrada',
    entry_report: 'Reporte de Entradas',
    entity:'Entidad',
    emails:'correos',
    //F
    facility_saved: 'planta guardada',
    facility_update: 'planta actualizada',
    file:'archivo',
    flammable:'Inflamable',
    from_or_equal: 'from or equal',
    //G
    general:'general',
    generate:'generar',
    //H
    headcount:'headcount',
    headquarter: 'headquarter', // sede ?
    headquarter_updated: 'headquarter updated',
    hired:'contratados',
    hsbc:'HSBC',
    //I
    id:'id',
    is_active:'is active',
    is_direct_funds_mode:'is direct funds mode',
    is_review_at_origin:'¿Es revisión de origen?',
    is_this_file_a_packing_slip:'¿Este archivo es un Packing Slip?',
    in_inventary:'En inventario',
    in_compliance:'En cumplimiento',
    in_review:'En revisión',
    indirect:'indirecto',
    indirect_required:'indirectos',
    company_profile:'Perfil de la Empresa',
    invoice:'factura',
    invoice_day:'invoice day',
    invoice_file:'Archivo Factura',
    invoice_type:'tipo de factura',
    it_doesn_not:'no lo es',
    invalid_date:'Fecha inválida',
    incomplete:'incompleta',
    ingnore_taxes:'ignorar impuestos',
    //J
    //K
    //L
    label: 'etiqueta',
    last_update:'última actualización',
    latitude:'latitud',
    length: 'longitud',
    load_order: 'orden de carga',
    located_at: 'localizado en',
    location: 'localización',
    locked: 'Bloqueado',
    longitude:'longitud',
    //M
    main_email:'correo electrónico principal',
    mail_server:'Servidor de Correos',
    mail:'Correo',
    manager_email: 'Correo Electrónico de gerente',
    manager_name: 'nombre de gerente',
    manager_phone: 'teléfono de gerente',
    manual_expense: 'Gasto manual',
    max_hours_for_regular_rate: 'max hours for regular rate',
    missing_category_or_client: 'falta categoria o cliente',
    model: 'modelo',
    market_average:'market average',
    mxn_funds_transfer: 'mxn funds transfer',
    MXN:'MXN',
    next: 'siguiente',
    monthly:'Mensual',
    //N
    no: 'no',
    no_order: '# orden',
    no_part: '# parte',
    no_assigned_documents:'Sin documentos asignados',
    number: 'número',
    new_expense: 'nuevo gasto',
    notes:'notas',
    //O
    ok: 'ok',
    order_date: 'fecha de order',
    order_status: 'estado de la orden',
    or_new_company: 'o nueva compañia',
    original: 'original',
    other_emails:'otros correos electrónicos',
    overtime:'Tiempo Extra',
    //P
    pallets_in_warehouse_by_client: 'pallets en almacén por cliente',
    purchase_orders:'Ordenes de Compra',
    pay_date: 'Fecha Pago',
    pending_shelter_fees:'Shelter Fees pendientes',
    percentage:'Porcentaje',
    percent_invalid:'la suma de los porcentajes debe ser igual a 100',
    planned: 'Planificado',
    plates: 'matrícula',
    po_number: 'Número de Pedido|Orden de Compra',
    phone:'teléfono',
    position:'puesto',
    position_title:'Título del Puesto',
    previous: 'anterior',
    provider: 'proveedor',
    preview:'Vista Previa',
    progress:'progreso',
    precisoft:'Precisoft',
    //Q
    quality:'Calidad',
    //R
    registers_will_be_exported:'registros serán exportados',
    rate: 'rate|rates', //tarifas
    rate_updated: 'rate actualizado',
    retained:'retenido',
    reject: 'Rechazar',
    rejected:'Rechazado',
    rfc:'RFC',
    recruitment:'Reclutamiento',
    remaining_days:'Días restantes',
    representative: 'representative',
    repse:'REPSE',
    recepcion:'Recepcion',
    required:'requerido',
    requests:'Solicitudes',
    request_inventary: 'solicitar inventario',
    request_date:'Fecha de solicitud',
    request_documents:'Solicitud de documentos',
    requirement_number: 'número de pedimento',
    requirement_key: 'clave de pedimento',
    resume: 'resumen',
    retained_iva:'IVA Retenido',
    retained_isr:'ISR Retenido',
    review_at_origin:'revisión de origen',
    review_order: 'orden de revisión|ordenes de revisión',
    reviewed_by: 'revisado por',
    reviewer: 'revisor',
    rfc: 'RFC',
    //S
    salary_survey:'salary survey',
    salary_comparison:'salary comparison',
    save_settings:'guardar  configuracion',
    sca_file_name: 'SCA file name',
    schedule_day_invoice: 'schedule day invoice',
    send:'enviar',
    serie: 'serie',
    series: 'series',
    short_name: 'nombre corto',
    shift:'turno',
    sidebar_salary_survey:'Salary Survey',
    sidebar_salary_comparison:'Salary Comparison',
    sidebar_human_resources:'Recursos Humanos',
    sidebar_contralor_report:'Reporte Contralor',
    sidebar_contralor_config:'Configuración',
    sidebar_entries: 'Entradas',
    import_export: 'Import & Export',
    sidebar_load_order: 'Órdenes de Carga',
    sidebar_review_orders: 'Ordenes de revisión',
    sidebar_discrepancy: 'Discrepancias',
    soon_to_expired: 'Proto caducara',
    state: 'estado',
    subject:'Asunto',
    subtotal:'Subtotal',
    subtotals:'Subtotales',
    supplier: 'proveedor',
    //T
    tax:'Impuesto',
    tacna_average:'TACNA average',
    test:'test',
    there_is:'Hay',
    this_entry_will_change_to: 'esta entrada cambiará a',
    this_is_RO: 'es RO',
    this_review_order_status_will_change_to_ready_for_review:
      'El estado de esta orden de revisión cambiara a Ready for review.',
    this_will_request_a_inventary: 'esto solicitará un inventario.',
    time_period:'periodo de tiempo',
    timeline: 'linea de tiempo',
    to_or_equal: 'to or equal',
    tracking: 'seguimiento',
    transporter: 'transportista',
    trailer: 'camión',
    //U
    unlocked: 'Desbloqueado',
    unit_cost:'costo unitario',
    updated: 'actualizado',
    ups:'altas',
    update_vendor_payday:'actualizar Payday de proveedor',
    usd_funds_transfer: 'usd funds transfer',
    USD:'USD',
    USD_EST:'USD EST.',
    user:'Usuario',
    //V
    validations: 'validaciones',
    validate_document:'validar documento',
    vendor_name:'nombre proveedor',
    vendor_email:'correo electrónico de proveedor',
    //W
    warehouse: 'almacén',
    warehouse_aging: 'warehouse aging',
    warehouse_code: 'código almacén',
    weight: 'peso',
    widget_compliance_by_status:'Compliance - Estado de cumplimiento',
    widget_discrepancies_by_supplier:'Discrepancias - Por Proveedor',
    widget_discrepancies_by_type:'Discrepancias - Por Tipo',
    widget_discrepancies_by_client:'Discrepancias - Por Cliente',
    widget_ehs_by_status:'EHS - Estado de cumplimiento',
    widget_entries_by_aging:'Entradas - Por Antigüedad',
    widget_entries_by_warehouse_capacity:'Entradas - Capacidad de Almacén',
    widget_entries_by_status:'Entradas - Por Estado',
    widget_invoiced_expenses:'Contabilidad - Gastos Por Pagar',
    widget_load_order_by_status:'Ordenes de Carga - Por Estado',
    widget_pending_expenses:'Contabilidad - Gastos Pendientes',
    widget_rejected_expenses:'Contabilidad - Gastos Rechazados',
    widget_review_oder_by_client:'Ordenes de Revisión - Por Cliente',
    widget_review_oder_by_status:'Ordenes de Revisión - Por Estado',
    //X
    //Y
    yes: 'Sí',
    //Z
    zip: 'CP',
    zone: 'zona',
    zone_id: 'ID Zona'
  }
}
